import { html, svg, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseIcon } from './_base';

@customElement('icon-spin')
class IconSpin extends BaseIcon {
  static override styles = css`
    :host {
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .opacity-25 {
      opacity: 0.25;
    }
    .opacity-75 {
      opacity: 0.75;
    }
  `;

  override viewBox: string = '0 0 24 24';

  @property({ type: String, attribute: 'animate-duration', reflect: true })
  animateDuration: string = '1s';

  override render() {
    return html`
      <svg
        width=${this.size}
        xmlns="http://www.w3.org/2000/svg"
        viewBox=${this.viewBox}
        fill=${'none'}
      >
        ${this.content()}
      </svg>
    `;
  }

  override content() {
    return svg`
      <animateMotion dur="6s" repeatCount="indefinite" rotate="0" />
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke=${this.color} stroke-width="4"></circle>
      <path class="opacity-75" fill=${this.color} d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur=${this.animateDuration}
          repeatCount="indefinite"
        />
      </path>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'icon-spin': IconSpin;
  }
}
